(() => {
  if (window.MHResponsive) return;
  window.MHResponsive = true;
  // Offer account choices while preserving direct sign-in without JavaScript.
  const syncAccountEntry = () => {
    document.querySelectorAll('[data-mh-account-entry]').forEach(link => {
      const dialog = document.getElementById(link.dataset.mhAccountEntry);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', dialog.id);
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-mh-account-entry]');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
      const dialog = document.getElementById(link.dataset.mhAccountEntry);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
      return;
    }
    const dialog = event.target.closest('.mh-account-entry');
    if (!dialog?.open) return;
    const rect = dialog.getBoundingClientRect();
    const backdrop = event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
    if (backdrop || event.target.closest('[data-mh-account-close], .mh-account-entry__action')) dialog.close();
  });
  document.addEventListener('shopify:section:load', syncAccountEntry);
  syncAccountEntry();
  if (!customElements.get('mh-announce-carousel')) {
    customElements.define('mh-announce-carousel', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.mh-announce__rail');
        if (!this.rail || this.rail.children.length < 2) return;
        this.events = new AbortController();
        const options = {signal: this.events.signal};
        this.phone = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.hovered = false;
        this.touching = false;
        this.visible = false;
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.hovered = true; this.stop(); }
        }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.start(); }, options);
        this.rail.addEventListener('pointerdown', () => { this.touching = true; this.stop(); }, options);
        for (const type of ['pointerup', 'pointercancel']) {
          window.addEventListener(type, () => { this.touching = false; this.start(); }, options);
        }
        this.rail.addEventListener('focusin', () => this.stop(), options);
        this.rail.addEventListener('focusout', () => this.start(), options);
        document.addEventListener('visibilitychange', () => this.start(), options);
        this.phone.addEventListener('change', () => this.start(), options);
        this.reduced.addEventListener('change', () => this.start(), options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.start();
        });
        this.observer.observe(this);
        this.setAttribute('data-ready', '');
      }
      stop() { clearInterval(this.timer); }
      start() {
        this.stop();
        if (!this.phone.matches || this.reduced.matches || this.hovered || this.touching || !this.visible || document.hidden) return;
        this.timer = setInterval(() => {
          if (!this.phone.matches || this.reduced.matches || this.hovered || this.touching || !this.visible || document.hidden || this.rail.matches(':focus-within')) return;
          const width = this.rail.clientWidth;
          if (!width) return;
          const index = Math.round(Math.abs(this.rail.scrollLeft) / width);
          const next = (index + 1) % this.rail.children.length;
          const direction = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
          this.rail.scrollTo({left: next * width * direction, behavior: this.reduced.matches ? 'instant' : 'smooth'});
        }, 5000);
      }
      disconnectedCallback() {
        this.stop();
        this.events?.abort();
        this.observer?.disconnect();
      }
    });
  }
  // Tab bar search: open the masthead search panel instead of leaving the page.
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-mh-tabbar-search]');
    if (!link) return;
    const toggle = document.querySelector('[data-mh-search-toggle]');
    if (!toggle) return;
    event.preventDefault();
    toggle.click();
  });
  const root = document.documentElement;
  const observed = new Set();
  let frame = 0;
  const setSize = (name, value) => {
    const next = `${Math.ceil(value)}px`;
    if (root.style.getPropertyValue(name) !== next) root.style.setProperty(name, next);
  };
  const update = () => {
    frame = 0;
    const header = document.querySelector('.mh-header-sticky');
    const bars = document.querySelectorAll('.mh-mobile-buy, .mh-project-savings__trigger, .mh-tabbar');
    const height = header?.getBoundingClientRect().height || 0;
    setSize('--mh-sticky-header-height', height);
    setSize('--mh-scroll-offset', height + 24);
    let bottom = 0;
    bars.forEach(bar => {
      const style = getComputedStyle(bar);
      if (style.position === 'fixed' && style.display !== 'none' && bar.getClientRects().length) {
        bottom = Math.max(bottom, bar.getBoundingClientRect().height + (parseFloat(style.bottom) || 0));
      }
    });
    setSize('--mh-fixed-bottom', bottom);
    let active = document.activeElement;
    while (active?.shadowRoot?.activeElement) active = active.shadowRoot.activeElement;
    const editing = active?.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, select, [contenteditable="true"]');
    const viewport = window.visualViewport;
    setSize('--mh-visual-viewport-height', viewport?.height || window.innerHeight);
    setSize('--mh-visual-viewport-top', viewport?.offsetTop || 0);
    root.toggleAttribute('data-mh-keyboard-open', Boolean(editing && viewport && viewport.scale === 1 && window.innerHeight - viewport.height > 150));
    const launcher = document.querySelector('#__helpdesk-channel .helpdesk-channel-start-btn');
    if (launcher && !launcher.dataset.mhAccessible) {
      launcher.dataset.mhAccessible = 'true';
      launcher.setAttribute('role', 'button');
      launcher.tabIndex = 0;
      const label = launcher.querySelector('.helpdesk-channel-start-text')?.textContent.trim();
      if (label) launcher.setAttribute('aria-label', label);
      launcher.addEventListener('keydown', event => {
        if (event.target === launcher && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          launcher.click();
        }
      });
    }
    for (const element of [header, ...bars]) {
      if (element && !observed.has(element)) {
        observed.add(element);
        resize?.observe(element);
      }
    }
    for (const element of observed) {
      if (!element.isConnected) {
        resize?.unobserve(element);
        observed.delete(element);
      }
    }
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length || record.removedNodes.length)) schedule();
  }).observe(document.body, {childList: true, subtree: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('resize', schedule, {passive: true});
  window.visualViewport?.addEventListener('scroll', schedule, {passive: true});
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  schedule();
})();

// WIG pass 2 (2026-09-12): Dawn customer forms (login / register / recover / reset / activate / addresses) post and
// navigate. Mark the submit control busy once the request has started so a slow round-trip is not re-submitted.
(() => {
  document.querySelectorAll('.customer form').forEach((form) => {
    form.addEventListener('submit', () => {
      const control = form.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
      if (control) control.setAttribute('aria-busy', 'true');
    });
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.customer [aria-busy="true"]').forEach((control) => control.removeAttribute('aria-busy'));
  });
})();
